import { make } from 'vuex-pathify'
import Task from '@/api/task'

const taskDefault = {
  project: {},
  user: {},
  records: [],
  employee_review: {},
  manager_review: {},
  files: [],
  tickets: []
}

const state = {
  task: {
    ...taskDefault
  }
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),

  PUSH_TASK_RECORD: (state, payload) => {
    state.task.records.push(payload)
  },

  PUSH_TASK_TICKET: (state, payload) => {
    state.task.tickets.push(payload)
  },

  UPDATE_TASK_RECORD: (state, payload) => {
    const originTaskRecords = [...state.task.records]
    const filteredTaskRecords = originTaskRecords.filter(
      (item) => item.id !== payload
    )
    state.task.records = filteredTaskRecords || []
  },

  SET_TASK_RECORDS: (state, payload) => {
    state.task.records = payload
  }
}

const actions = {
  async getTask({ commit }, id) {
    const params = {
      _include: [
        'project',
        'project.manager',
        'records',
        'records.files',
        'records.lastComments.user',
        'records.lastComments.files',
        'tickets',
        'tickets.files',
        'employeeReview',
        'managerReview',
        'files'
      ]
    }

    try {
      commit('SET_TASK', {
        ...taskDefault
      })
      const response = await Task.getTask(id, params)
      commit('SET_TASK', response.data.task)
      return response
    } catch (e) {
      return false
    }
  },

  async getTaskRecords({ commit }, id) {
    const params = {
      _include: [
        'records',
        'records.files',
        'records.lastComments.user',
        'records.lastComments.files'
      ]
    }
    try {
      const response = await Task.getTask(id, params)
      commit('SET_TASK_RECORDS', response.data.task.records)
      return response
    } catch (e) {
      return false
    }
  },

  async complete({ commit, dispatch }, { id, data }) {
    try {
      const response = await Task.complete(id, data)
      const { message } = response
      dispatch('notify/show', message, { root: true })
      return response
    } catch (e) {
      return false
    }
  },

  async managerReview({ commit }, payload) {
    try {
      const response = await Task.managerReview(payload.id, payload)
      return response
    } catch (e) {
      return false
    }
  },

  async destroy({ commit, dispatch }, id) {
    try {
      const response = await Task.destroy(id)
      dispatch('notify/show', response.message, { root: true })
      return response
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
